// Formatos de la pantalla de Tiendas: dinero, porcentaje y forma de pago.
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';
import { FINANCIER_LABEL, financierOfSale } from '../../lib/financier';

const MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });

/** `null` es «no sé» y se pinta «—»; un `$0` diría «no vendió». */
export function money(cents: number | null): string {
    return cents === null ? '—' : MXN.format(cents / 100);
}

/** El `fmtMoneyShort` del mockup: `$4.5K` arriba de mil, `$450` abajo. */
export function moneyShort(cents: number | null): string {
    if (cents === null) return '—';
    const pesos = cents / 100;
    if (Math.abs(pesos) >= 1000) return `$${(pesos / 1000).toFixed(1)}K`;
    return `$${String(Math.round(pesos))}`;
}

/** Forma de pago con nombre completo: Contado, Crédito SK o la financiera. `null` si no se sabe. */
export function paymentLabel(
    sale: Pick<BackofficeSale, 'type' | 'externalProvider'>,
): string | null {
    const financier = financierOfSale(sale);
    if (financier === null) return null;
    if (financier === 'SUREKEEP') return 'Crédito SK';
    return FINANCIER_LABEL[financier];
}
